import { FC, Ref } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { NakedButton } from '@frontend/design-system';
import { useChatbotAssistant } from '../../provider/chatbot-assistant.provider';
import { AssistantCollapseBadge, AssistantStatusBadge } from '../assistant-status-badge';

export const TriggerButton: FC<{ innerRef: Ref<HTMLButtonElement> }> = ({ innerRef }) => {
  const { t } = useTranslation('aiOnboarding');
  const { isOpen, toggleChatbotOpen } = useChatbotAssistant();

  return (
    <NakedButton
      ref={innerRef}
      css={[styles.container, isOpen && styles.gradientBorder]}
      onClick={toggleChatbotOpen}
      aria-label={isOpen ? t('Close Chatbot') : t('Open Chatbot')}
    >
      {isOpen ? <AssistantCollapseBadge /> : <AssistantStatusBadge />}
    </NakedButton>
  );
};

const styles = {
  container: css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid ${theme.colors.neutral20};
    border-radius: ${theme.borderRadius.medium};
    padding: ${theme.spacing(1)};
    width: 48px;
    height: 48px;
    cursor: pointer;
  `,
  gradientBorder: css`
    border: none;
    background: ${theme.colors.white};

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      padding: 2px;
      background: linear-gradient(
        45.06deg,
        #ff7301 2.26%,
        ${theme.colors.secondary.eggplant50} 50%,
        ${theme.colors.secondary.seaweed50} 97.74%
      );
      border-radius: ${theme.borderRadius.medium};
      mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
      mask-composite: xor;
      -webkit-mask-composite: xor;
    }
  `,
};
